// extracted by mini-css-extract-plugin
export default {"wrapper":"yA-z","button":"zA-z","alternate":"AA-z","disabled":"BA-z","paymentWarning":"CA-z","fadeIn":"DA-z"};